module.exports = __webpack_public_path__ + "img/ic-barchart.e01dea38.svg";